var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/treatment-leave-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-48451a8c!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/treatment-leave-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TreatmentLeaveList.vue
// module id = 1365
// module chunks = 1